import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReportStatePanel } from './ReportStatePanel/ReportStatePanel';
import classes from './ReportNotFoundState.module.css';

interface IReportNotFoundStateProps {
  /** Destination for the back link. Every report returns to the
   * analytics index at `/analytics/:siteId` — callers pass the resolved href. */
  backHref: string;
  /** i18n key for the not-found heading. */
  notFoundKey: string;
  /** i18n key for the "back to analytics" link label. */
  backKey: string;
}

/**
 * Shared not-found state for analytics report pages. Renders the
 * ReportStatePanel chassis with an info icon and a `<Link>` back to the
 * caller-supplied analytics index.
 */
export function ReportNotFoundState({ backHref, notFoundKey, backKey }: IReportNotFoundStateProps) {
  const { t } = useTranslation();
  return (
    <ReportStatePanel
      icon="info"
      titleKey={notFoundKey}
      action={
        <Link className={classes.backLink} to={backHref}>
          {t(backKey)}
        </Link>
      }
    />
  );
}
